import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 16;
const DEFAULT_HEIGHT = 16;

function IconSplitToSubsection({ width, color }: Omit<IconProps, "height" | "class">) {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg width={width} height={height} viewBox="0 0 16 16">
            <g fill={color} fill-rule="evenodd">
                <rect fill-opacity=".35" x="5" width="2" height="16" rx="1"/>
                <rect x="9" y="8" width="2" height="8" rx="1"/>
            </g>
        </svg>
    );
}

IconSplitToSubsection.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "var(--teflon)"
};

export default IconSplitToSubsection;
